import type { FormFieldBlock } from '@payloadcms/plugin-form-builder/types';

type FormBlockType = FormFieldBlock['blockType'];

export const initialFormState = (fields: FormFieldBlock[]) => {
  return fields?.reduce(
    (initialSchema, field) => {
      if (!('name' in field)) return initialSchema;

      const { blockType, name } = field;
      const defaultValue = 'defaultValue' in field ? field.defaultValue : undefined;

      switch (blockType as FormBlockType) {
        case 'checkbox':
          initialSchema[name] = defaultValue || false;
          return initialSchema;

        case 'textarea':
        case 'email':
        case 'text':
        case 'select':
        case 'country':
        case 'state':
          initialSchema[name] = defaultValue || '';
          return initialSchema;

        default:
          console.warn(`Unhandled form field type: ${blockType}`);
          initialSchema[name] = defaultValue || '';
          return initialSchema;
      }
    },
    {} as Record<string, string | boolean>,
  );
};
